import request from "@/utils/request";

export function getAllGerminatedBatchOptions() {
    return request({
        url: "/api/services/app/GerminationBatch/GetAllForDropDown",
        method: "GET"
    });
}

export function germinationBatchGet(params) {
    return request({
        url: "/api/services/app/GerminationBatch/Get",
        method: "GET",
        params
    });
}

export function germinationBatchCreate(data) {
    return request({
        url: "/api/services/app/GerminationBatch/Create",
        method: "POST",
        data
    });
}

export function germinationBatching(data) {
    return request({
        url: "/api/services/app/GerminationBatch/Batching",
        method: "POST",
        data
    });
}

export function germinationBatchUpdate(data) {
    return request({
        url: "/api/services/app/GerminationBatch/Update",
        method: "PUT",
        data
    });
}

export function germinationBatchUpdateWithTransaction(data) {
    return request({
        url: "/api/services/app/GerminationBatch/UpdateWithTxn",
        method: "PUT",
        data
    });
}

export function germinationBatchPatch(data) {
    return request({
        url: "/api/services/app/GerminationBatch/Patch",
        method: "PATCH",
        data
    });
}

export function germinationBatchPatchMany(data) {
    return request({
        url: "/api/services/app/GerminationBatch/PatchMany",
        method: "PATCH",
        data
    });
}

export function germinationBatchDelete(params) {
    return request({
        url: "/api/services/app/GerminationBatch/Delete",
        method: "DELETE",
        params
    });
}

export function germinationBatchDeleteMany(data) {
    return request({
        url: "/api/services/app/GerminationBatch/DeleteMany",
        method: "POST",
        data
    });
}


// WEBPACK FOOTER //
// ./src/api/germination_batch.js